import React from "react";

import { API_ENDPOINT } from "../../../constants/appConstant";
import { useNetwork } from "../../../hooks/useNetwork";
import { ApopProps } from "../../../types";
import { Events } from "../common/json/clevertapEvents";
import { EducationDetailsApopUI } from "./EducationDetailsUI";
import { getSubmitData } from "./getSubmitData";
import "./styles.css";

export const EducationDetailsApop = ({
  nextApopType,
  onCTA,
  toast,
  prefilledData,
  closeApop,
  handleEventTracking,
}: ApopProps) => {
  const { response: apiResponse, fetchData: submitFetchApi } = useNetwork();

  const onSubmit = async (
    data: any,
    isSpecificationDisabled: boolean,
    isBoard: boolean,
  ) => {
    const updatedData = getSubmitData(
      isSpecificationDisabled,
      isBoard,
      data,
      handleEventTracking,
    );

    handleEventTracking({
      eventType: "eventPush",
      eventName: Events["EDUCATION_DETAILS"].submitEvent["EVENTNAME"],
      eventProps: Events["EDUCATION_DETAILS"].submitEvent["EVENTOBJ"],
    });

    const res = await submitFetchApi(
      API_ENDPOINT().seekerProfile.educationDetailsMiddleware,
      "POST",
      {},
      updatedData,
    );

    onCTA && onCTA("EDUCATION_DETAILS");
    if (res.data) {
      const nextAction = (res.data as any)?.nextActionRequired?.actionType;
      nextApopType(
        nextAction ?? "",
        (res.data as any)?.nextActionRequired ?? null,
      );
      toast &&
        toast({
          showToast: true,
          text:
            (res.data as any)?.successMessage ?? "Section updated successfully",
          type: "success",
        });

      if (data.linkedin) {
        handleEventTracking({
          eventType: "eventPush",
          eventName: Events["LINKED_IN"].linkedInAdded["EVENTNAME"],
          eventProps: Events["LINKED_IN"].linkedInAdded["EVENTOBJ"],
        });
      }
    } else {
      toast &&
        toast({
          showToast: true,
          text:
            (res.error as any)?.error?.message?.errorMessage ??
            "Something went wrong",
          type: "error",
        });
    }
  };

  return (
    <EducationDetailsApopUI
      prefilledData={prefilledData}
      closeApop={closeApop}
      onSubmit={onSubmit}
      isSubmitAPILoading={apiResponse.isLoading}
    />
  );
};
